// extracted by mini-css-extract-plugin
export default {"box":"TrendBlock_box__kWr80","trend":"TrendBlock_trend__v+2zO","name":"TrendBlock_name__68Vou","amount":"TrendBlock_amount__DVqiN"};